module.exports = __webpack_public_path__ + "img/Pinang by Raya.6c29c906.png";